














































import { defineComponent, ref, computed, PropType, onUnmounted } from '@vue/composition-api';
import { AddCircleIcon, UserIcon, CheckCircleIcon, SearchIcon } from 'tdesign-icons-vue';

import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';

import { showPhoneOrAccountName } from '@/renderer/components/dialog/AddTransfer/compositions/useTools';

export interface TemporaryMemberListRef {
  total: number;
}

export default defineComponent({
  name: 'TemporaryMemberList',
  components: {
    AddCircleIcon,
    UserIcon,
    CheckCircleIcon,
    SearchIcon,
  },
  props: {
    originMembers: {
      type: Array as PropType<CoFile.TeamOrMemberItem[]>,
      required: true,
    },
    addedMembers: {
      type: Array as PropType<CoFile.TeamOrMemberItem[]>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const temporaryList = ref<SMH.ExtUserListItemData[]>([]);
    const temporaryKeyword = ref('');
    const temporaryKeywordCache = ref('');
    const total = ref(0);
    const loading = ref(false);

    const renderTemporaryList = computed(() => {
      const { originMembers, addedMembers } = props;
      const originMemberIdsSet = new Set(originMembers.map(item => item.userId as number));
      const addedMemberIdsSet = new Set(addedMembers.map(item => item.userId as number));

      temporaryList.value.forEach(item => {
        item.added = false;
        item.newAdd = false;
        if (originMemberIdsSet.has(item.userId) && addedMemberIdsSet.has(item.userId)) {
          item.added = true;
        } else if (addedMemberIdsSet.has(item.userId)) {
          item.newAdd = true;
        }
      });
      return temporaryList.value;
    });

    const methods = {
      async pullList() {
        loading.value = true;
        const opts = {
          page: 1,
          pageSize: 1000,
          keyword: temporaryKeyword.value,
        };
        try {
          const { data } = await smh.userAPI.getExtUserList({
            ...opts,
          });
          const { totalNum, contents } = data;
          temporaryList.value = contents.map(item => ({
            ...item,
            name: item.nickname,
            userId: item.id,
            inactive: false, // 默认给一个是否未激活，暂时与团队保持一致
          }));

          total.value = totalNum;
        } catch (e) {
          tips.error(e as MsgError);
        } finally {
          loading.value = false;
        }
      },
      onSearchTemporaryMember(val: string) {
        if (temporaryKeywordCache.value === val.trim()) return;
        temporaryKeywordCache.value = val.trim();
        methods.pullList();
      },
      addMember(item: CoFile.TeamOrMemberItem) {
        emit('add', { ...item, isTemporary: true });
      },
      initData() {
        methods.pullList();
      },
      resetData() {
        temporaryKeyword.value = '';
        temporaryKeywordCache.value = '';
      },
    };

    methods.initData();

    onUnmounted(() => {
      methods.resetData();
    });

    return {
      total,
      loading,
      temporaryKeyword,
      renderTemporaryList,
      showPhoneOrAccountName,
      ...methods,
    };
  },
});
